// @ts-check

import { createBankAccount, getBankAccounts } from '@/api/bankAccounts'

/** @returns {BankAccountModuleState} */
const initBankAccountState = () => ({
  bankAccounts: null
})

/** @type {BankAccountMutationTree} */
const bankAccountMutations = {
  setBankAccounts: (state, accounts) => {
    state.bankAccounts = accounts
  }
}

/** @type {BankAccountGetterTree} */
const bankAccountGetters = {
  findAccountById:
    ({ bankAccounts }) =>
    (accountId) =>
      bankAccounts?.find(({ id }) => id === accountId) ?? null,

  bankAccounts: ({ bankAccounts }) => bankAccounts,

  defaultBankAccount: ({ bankAccounts }) =>
    bankAccounts?.find((account) => account.is_default) ?? null,

  swanBankAccount: ({ bankAccounts }) =>
    bankAccounts?.find((account) => account.is_swan_account) ?? null,

  webServiceAccount: ({ bankAccounts }) =>
    bankAccounts?.find((account) => account.is_ws_connected) ?? null,

  hasActivePsd2Connection: ({ bankAccounts }) =>
    (bankAccounts || []).some(
      ({ is_connection_expired: isConnectionExpired = null }) =>
        isConnectionExpired === false
    )
}

/** @type {BankAccountActionTree} */
const bankAccountActions = {
  async getBankAccounts({ commit }) {
    commit('setBankAccounts', null)
    const bankAccounts = await getBankAccounts()
    commit('setBankAccounts', bankAccounts)
    return bankAccounts
  },

  async createBankAccount({ dispatch }, bankAccountData) {
    const bankAccount = await createBankAccount(bankAccountData)
    await dispatch('getBankAccounts')
    return bankAccount
  }
}

export const bankAccountModule = {
  namespaced: true,
  state: initBankAccountState,
  actions: bankAccountActions,
  mutations: bankAccountMutations,
  getters: bankAccountGetters
}

export default bankAccountModule
